import PhysicalLocation from "./physicalLocation"
import CropYear from "./cropYear";
import FuturesContract from "./futuresContract";
import Commodity from "./commodity";
import { formatUTCDate } from "common/formatters";
import { Unit } from "./unit";
import UserGroup from "./userGroup";
import { DeliveryMethod } from "./deliveryMethod";

export default interface DeliveryPeriod {
    id: string;
    name: string;
    erpName: string;
    contract: FuturesContract;
    secondaryContract?: FuturesContract;
    commodity: Commodity;
    cropYear: CropYear;
    defaultDeliveryMethod?: DeliveryMethod;
    traderGroups: UserGroup[];
    start: Date;
    end: Date;
    startString?: string;
    endString?: string;
    htaFee: number;
    premium: number;
    lastUpdatedDateUtc: Date;
    lastUpdatedBy: string;
    bids: Bid[];
    visibility: DeliveryPeriodVisibility;
    isSpot: boolean;
    isProtected: boolean;
}

export function getDeliveryPeriodDisplayName(dp: DeliveryPeriod): string {
    //for delayedPrice contracts deliveryPeriod wont't be set but while retrieving them from DB deliveryPeriod.commodity will be set     
    //with all other deliveryPeriod properties as null
    if (dp?.id == null) return "";
    return dp.name ?? `${formatUTCDate(dp.start)}-${formatUTCDate(dp.end)}`;
}

export interface Bid {
    id: string;
    location: PhysicalLocation | null;
    basis: number;
    cash: number;
    isBasisLocked?: boolean;
    useSecondarySymbol?: boolean;
}

export const defaultBid: Bid = {
    id: "",
    location: null,
    basis: 0,
    cash: 0,
    isBasisLocked: false,
    useSecondarySymbol: false
};

export interface Region {
    regionId: string;
    locationIds: string[];
    isSelected: boolean;
}

export interface CommoditySettings {
    commodityId: number;
    regions: Region[];
    selectedUnit: Unit;
    selectedBidGroups?: string[];
}

export enum DeliveryPeriodVisibility {
    Public = 1,
    InternalOnly = 2,
    BidEditorOnly = 3
}

export function getDeliveryPeriodVisibilityText(visibility: DeliveryPeriodVisibility): string {
    switch (visibility) {
        case DeliveryPeriodVisibility.Public:
            return "Public";
        case DeliveryPeriodVisibility.InternalOnly:
            return "Internal Only";
        case DeliveryPeriodVisibility.BidEditorOnly:
            return "Bid Editor Only";
        default:
            throw new Error("Unknown visibility");
    }
}